import { acidPulse } from "@/acid";

const rand = (a, b) => a + Math.random() * (b - a);

export const afx = {
  id: "afx",
  name: "AFX",
  subtitle: "Acid techno strobes, scope lines and glitch blocks",
  init() {
    return { beat: 0, blocks: [] };
  },
  draw(ctx, w, h, t, s, p) {
    const bpm = 132;
    const beat = Math.floor((t * bpm) / 60);
    const hit = beat !== s.beat;
    s.beat = beat;
    const since = (performance.now() - acidPulse.last) / 1000;
    const acid = acidPulse.v * Math.max(0, 1 - since * 3);
    ctx.globalCompositeOperation = "source-over";
    const strobe = Math.floor(performance.now() / 900);
    if (strobe !== s.strobe) { s.strobe = strobe; s.flash = 1; window.__afxStrobes = (window.__afxStrobes || 0) + 1; }
    s.flash = (s.flash || 0) * 0.86;
    ctx.fillStyle = "rgba(4,4,4,0.35)";
    ctx.fillRect(0, 0, w, h);
    if (s.flash > 0.05) { ctx.fillStyle = `rgba(255,240,0,${0.6 * s.flash})`; ctx.fillRect(0, 0, w, h); }
    const gap = Math.max(28, Math.min(w, h) / 14);
    ctx.strokeStyle = `rgba(255,240,0,${0.08 + acid * 0.2})`;
    ctx.lineWidth = 1;
    ctx.beginPath();
    for (let x = (t * 40) % gap; x < w; x += gap) { ctx.moveTo(x, 0); ctx.lineTo(x, h); }
    for (let y = 0; y < h; y += gap) { ctx.moveTo(0, y); ctx.lineTo(w, y); }
    ctx.stroke();
    if (hit) {
      for (let i = 0; i < 3 + acid * 6; i++) {
        s.blocks.push({ x: rand(0, w), y: rand(0, h), bw: rand(20, w * 0.3), bh: rand(4, 40), life: 1, c: Math.random() < 0.5 ? "255,240,0" : Math.random() < 0.5 ? "255,43,214" : "230,230,230" });
      }
    }
    s.blocks = s.blocks.filter((b) => {
      b.life -= 0.06;
      ctx.fillStyle = `rgba(${b.c},${b.life * 0.8})`;
      ctx.fillRect(b.x, b.y, b.bw, b.bh);
      return b.life > 0;
    });
    ctx.lineWidth = 3;
    for (let l = 0; l < 3; l++) {
      const cy = h * (0.3 + l * 0.2);
      const amp = h * (0.05 + acid * 0.12 + p * 0.05);
      ctx.strokeStyle = l === 1 ? "#ffef00" : `rgba(${l ? "255,43,214" : "0,255,208"},0.8)`;
      ctx.beginPath();
      for (let x = 0; x <= w; x += 6) {
        const ph = x * 0.02 + t * (4 + l);
        const saw = ((ph / Math.PI) % 2) - 1;
        const y = cy + amp * (l === 1 ? saw : Math.sign(Math.sin(ph * 0.5)) * 0.6 + Math.sin(ph) * 0.4);
        x ? ctx.lineTo(x, y) : ctx.moveTo(x, y);
      }
      ctx.stroke();
    }
    const size = Math.min(w, h) * (0.16 + acid * 0.05 + (hit ? 0.02 : 0));
    ctx.fillStyle = beat % 8 < 4 ? "#ffef00" : "#f2f2f2";
    ctx.font = `900 ${size}px "Arial Black", Impact, sans-serif`;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    const jitter = acid * 12;
    ctx.fillText("AFX", w / 2 + rand(-jitter, jitter), h / 2 + rand(-jitter, jitter));
  },
};
